import React from 'react';
import { DRUG_ICONS } from '../data/drugIcons';
import { HTN_REGIMEN_ICONS } from '../data/htnRegimenIcons';

/* Canonical filled gold-card glyph — renders a recraft-generated drug silhouette
   (keyed by drug_slug) in currentColor. Shared across the skill tree toast,
   gold-effect banner, pill cards, and anywhere a card needs its icon. Returns
   null for an unknown slug so callers can fall back. */
export default function RecraftGlyph({ slug, size = 14, className = '' }) {
  const glyph = DRUG_ICONS[slug] || HTN_REGIMEN_ICONS[slug];
  if (!glyph) return null;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={glyph.viewBox}
      fill="currentColor"
      stroke="none"
      aria-hidden="true"
    >
      {glyph.paths.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}
